import { useNavigate } from 'react-router-dom';
import utilities from '../../utils/utils';
import './userInfoForm.css';
import { useEffect, useState } from 'react';
import mockFunctions from '../../mockFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

const UserInfoForm = () => {

    

const navigate = useNavigate();

const [showExpandedForm, setShowExpandedForm] = useState(false);
const [showSubmitButton, setShowSubmitButton] = useState(false);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        city: '',
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        localStorage.setItem('userInfo', JSON.stringify(formData));
        navigate('/assessment/policy');
    };

    const getUserLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                let cityState = utilities.getCityStateFromLatLong(latitude, longitude)
                
                // You can use a reverse geocoding service to get the city name from coordinates
                // For simplicity, we'll just set a placeholder city name
                // setFormData({
                //     ...formData,
                //     city: 'Your City', // Replace with actual city name from reverse geocoding
                // });
                console.log(cityState);
            }, (error) => {
                console.error('Error getting location:', error);
            });
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    }

    const validateEmail = () => {
        if(mockFunctions.UserHasCompletedAssessment(formData.email)) {
            navigate('/assessment-results');
        } else {
            setShowExpandedForm(true);
            // setShowSubmitButton(false);
        }
    }
       

    const emailKeyDown = () => {
        if(formData.email && utilities.isValidEmail(formData.email)) {
            // setShowExpandedForm(true);
            setShowSubmitButton(true);
        } else {
            setShowSubmitButton(false);
        }
    };

    const goToAssessment = (e) => {
        e.preventDefault();
        navigate('/assessment/policy');
    };

    return (
        <div className="user-info-form-wrapper">
            <div className='user-info-left-wrapper'>
            <video
        className="video-background"
        src="https://videos.pexels.com/video-files/18471290/18471290-uhd_1440_2560_30fps.mp4"
        autoPlay
        muted
        loop
        playsInline
      ></video>
            </div>
        <div className='user-info-right-wrapper'>
            <form onSubmit={handleSubmit} className='user-info-form'>
                <>
                    <div>
                        <label htmlFor="email" className='email-label'>Enter you email address to get started:</label>
                        <input
                            type="email"
                            id="user-info-email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            onKeyDown={emailKeyDown}
                            placeholder='you@email.com'
                            required
                        />
                    </div><br></br>
                    {showExpandedForm && (
                        <>
                            <div className='first-name-div'>
                                <label htmlFor="firstName">First Name:</label>
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    className='half-width-input'
                                    required
                                    placeholder='John'
                                />
                            </div>
                            <div className='last-name-div'>
                                <label htmlFor="lastName" className='last-name-label'>Last Name:</label>
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    className='half-width-input'
                                    required
                                    placeholder='Doe'
                                />
                            </div><br></br>
                            <br></br>
                            <div className='city-div'>
                                <label htmlFor="city">City:</label>
                                <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                    placeholder='Your City'
                                /><button onClick={getUserLocation}className='locate-btn'><FontAwesomeIcon icon={faLocationDot} ></FontAwesomeIcon></button>
                            </div><br></br>
                        </>
                    )}
                    {showSubmitButton && (<button type="submit" className='user-info-submit-btn' onClick={showExpandedForm ? handleSubmit : validateEmail}>Submit</button>)}
                </>
            </form>
        </div>
        </div>
    );
};

export default UserInfoForm;